import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  FunctionField,
  ReferenceField,
  usePermissions,
} from 'react-admin'

import DeleteButton from '../../components/DeleteButton'
import FilterComponent from '../../components/Filter'
import KidSeriesStatusField from '../../components/KidSeriesStatusField'
import { ROLES } from '../../components/constants'

const Actions = props => {
  const { resource, currentSort, filterValues, exporter, basePath } = props
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={false}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={10000}
      />
    </TopToolbar>
  )
}

const KidSeriesFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search by title" source="title" alwaysOn />
  </FilterComponent>
)

const KidSeriesList = () => {
  const { permissions } = usePermissions()

  function timeConversion(duration) {
    const portions = []
    const msInHour = 60 * 60
    const hours = Math.trunc(duration / msInHour)
    portions.push(hours > 9 ? hours : `0${hours}`)
    duration = duration - hours * msInHour

    const msInMinute = 60
    const minutes = Math.trunc(duration / msInMinute)
    portions.push(minutes > 9 ? minutes : `0${minutes}`)
    duration = duration - minutes * msInMinute

    const seconds = Math.trunc(duration)
    portions.push(seconds > 9 ? seconds : `0${seconds}`)

    return portions.join(':')
  }

  return (
    <List
      bulkActionButtons={false}
      filters={<KidSeriesFilter />}
      actions={<Actions />}
      sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="id" />
        <TextField source="title" />
        <FunctionField
          render={value => timeConversion(value.duration || 0)}
          source="duration"
          label="Duration"
        />
        <DateField source="datePublished" label="Publish Date" />

        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <ReferenceField label="Created by" source="createBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Updated by" source="updateBy" reference="users">
          <TextField source="name" />
        </ReferenceField>
        <KidSeriesStatusField
          label="Publish"
          disabled={permissions !== ROLES.ADMIN && permissions !== ROLES.EDITOR}
        />

        <EditButton />
        <DeleteButton permissions={permissions} />
      </Datagrid>
    </List>
  )
}

export default KidSeriesList
